export default __webpack_public_path__ + "static/media/fiutur_logo.f59d1a11.png";